/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import {getPolicyMods, PolicyBasicInfo, PolicyIds} from "api/policy";
import AppShellTitle from "components/AppShellTitle";
import StatusBadge from "components/StatusBadge";
import {useApiQuery} from "hooks/api";
import {getPolicyModInEffectOrLatest} from "utils/quotePolicy";

export default function PolicyPageHeader({
  policyIds,
  status,
}: {
  policyIds: PolicyIds;
  status?: string | null;
}) {
  const {data: modList} = useApiQuery(getPolicyMods, {
    enabled: Boolean(!status || policyIds.policy_number || policyIds.policy_id),
  })(policyIds);
  let policyModInEffectOrLatest: PolicyBasicInfo | null = null;
  if (modList?.length) {
    policyModInEffectOrLatest = getPolicyModInEffectOrLatest(modList);
  }
  return (
    <div
      css={css`
        display: flex;
        gap: 14px;
        align-items: center;
      `}
    >
      <AppShellTitle>{policyIds.display_policy_number || ""}</AppShellTitle>
      {status ||
        (policyModInEffectOrLatest && (
          <StatusBadge value={status || policyModInEffectOrLatest.status} />
        ))}
    </div>
  );
}
